import { useApp } from "@/composables/useApp";
import { Store } from "pinia";
import { useBookingStore } from "./booking";
import { useBookingIdStore } from "./bookingId";
import { useEncounterStore } from "./encounters";
import { useFlowStore } from "./flow";
import { useOfferStore } from "./offer";
import { useRootStore } from "./root";
import { useTaskStore } from "./tasks";
import { useToastStore } from "./toast";

let hasLoggedIn = false;

export function resetStore() {
  const app = useApp();
  app?.config?.globalProperties.$taskNotesHub?.stop();
  app?.config?.globalProperties.$encountersHub?.stop();
  clearStore(useBookingStore());
  clearStore(useEncounterStore());
  clearStore(useFlowStore());
  if (hasLoggedIn) {
    clearStore(useBookingIdStore());
    clearStore(useOfferStore());
    clearStore(useToastStore());
  }
  clearStore(useTaskStore());

  function clearStore(store: Store) {
    store.$reset();
  }
}

export function hydrateStore() {
  hydrateStore(useRootStore());
  hydrateStore(useBookingStore());
  hydrateStore(useEncounterStore());
  hydrateStore(useFlowStore());
  hydrateStore(useOfferStore());
  hydrateStore(useTaskStore());
  hydrateStore(useToastStore());
  hydrateStore(useBookingIdStore());

  function hydrateStore(store: Store) {
    if (store?.$hydrate) store.$hydrate();
  }
}

export function subscribeToRootStore() {
  useRootStore().$subscribe((_, state) => {
    if (state.authenticated) hasLoggedIn = true;
    if (state.invalid && hasLoggedIn) hasLoggedIn = false;
    if (!state.authenticated) {
      resetStore();
    }
  });
}
